import { ampli } from '@/ampli';

import { trackEvent } from './track';

/**
 * Vocabulaires fermés de `filter_type`, fixés par le plan Amplitude. Ils diffèrent d'un event à
 * l'autre parce que les surfaces n'offrent pas les mêmes contrôles.
 */
export type DestinationFilterType = 'search' | 'specialty' | 'market' | 'sort';

export type ItineraryFilterType =
    | 'search'
    | 'incomplete'
    | 'view_mode'
    | 'reset'
    | 'travel_type'
    | 'duration'
    | 'city'
    | 'region';

export type ProjectListFilterType = 'search' | 'status' | 'dmc' | 'reset';

/**
 * Le texte saisi n'est jamais envoyé. Une recherche compte comme filtre appliqué quand le champ
 * passe de vide à non vide : compter chaque frappe ferait d'une seule recherche une rafale
 * d'events.
 */
export function isSearchStarted(previous: string | null, next: string | null): boolean {
    return (previous ?? '').trim() === '' && (next ?? '').trim() !== '';
}

export function trackDestinationFilter(
    destinationSlug: string,
    filterType: DestinationFilterType,
): void {
    trackEvent(() =>
        ampli.destinationFilterApplied({
            destination_slug: destinationSlug,
            filter_type: filterType,
        }),
    );
}

export function trackItineraryFilter(dmcId: string, filterType: ItineraryFilterType): void {
    trackEvent(() => ampli.itineraryFilterApplied({ dmc_id: dmcId, filter_type: filterType }));
}

export function trackProjectListFilter(filterType: ProjectListFilterType): void {
    trackEvent(() => ampli.projectListFiltered({ filter_type: filterType }));
}
